import {createFeatureSelector, createSelector} from '@ngrx/store';
import {AppNgrx} from '~model/ngrx/app-ngrx';
import {DEFAULT_THEME} from '../../../default-theme';

export const featureKeyApp = 'app';

export const selectFeature = createFeatureSelector<AppNgrx>(featureKeyApp);
export const loadMenuOpened = createSelector(selectFeature, state => state.menuOpened);
export const loadPalette = createSelector(selectFeature, state => state.palette ?? DEFAULT_THEME.mainColors.primary);
export const loadLogo = createSelector(selectFeature, state => state.logo);
